import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge must know our custom theme scale names, otherwise it would treat
 * e.g. `text-md` as a colour and drop it when merged with `text-fg`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["2xs", "xs", "sm", "base", "md", "lg", "xl", "2xl", "3xl", "4xl", "5xl"],
      radius: ["item", "control", "card", "panel", "photo", "pill"],
      shadow: ["xs", "sm", "md", "lg", "panel", "glow"],
      color: [
        "canvas", "frame", "surface", "surface-2", "surface-hover", "surface-raised", "input",
        "fg", "fg-soft", "fg-muted", "fg-subtle", "line", "line-strong", "control", "control-hover",
        "ink", "ink-fg", "ink-hover", "ink-hover-fg",
        "primary", "primary-hover", "primary-soft", "primary-soft-hover", "primary-ink", "primary-fg",
        "accent", "accent-soft", "accent-ink",
        "success", "success-soft", "success-ink", "info", "info-soft", "info-ink",
        "warning", "warning-soft", "warning-ink", "danger", "danger-soft", "danger-ink", "danger-solid", "danger-solid-hover",
        "neutral-soft", "neutral-ink", "ring", "overlay",
        "navy", "paper", "teal", "teal-bright", "blue", "gold", "coral", "saffron", "white", "black",
        "sidebar", "sidebar-fg", "sidebar-fg-strong", "sidebar-label", "sidebar-hover", "sidebar-active", "sidebar-active-fg", "sidebar-line", "sidebar-badge",
      ],
    },
  },
});

/** Compose class names; later Tailwind utilities win over earlier conflicting ones. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
